import { render, staticRenderFns } from "./NeedToFederateDialog.vue?vue&type=template&id=32f1e890&scoped=true"
import script from "./NeedToFederateDialog.vue?vue&type=script&lang=ts"
export * from "./NeedToFederateDialog.vue?vue&type=script&lang=ts"
import style0 from "./NeedToFederateDialog.vue?vue&type=style&index=0&id=32f1e890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1e890",
  null
  
)

export default component.exports